import React, {Component} from 'react'
import FormatMessage from "../messages/FormatMessage";
import EQLeftNavigation from './tags/EQLeftNavigationTree'
import {handleFormSubmit, submitFormData} from "../assets-static/scripts/Validation";
import {loadApplicationData, pageDetails, saveApplicationData} from "../actions/ApplicationAction";
import {isFirstPage} from "../assets-static/scripts/utils";
import {injectIntl} from "react-intl";
import dot from "dot-object";

                                    import RadioOptionWithValue from "./tags/RadioOptionWithValue";
                                        import {EQ_Button_Navigation} from "./tags/EQ_Button_Navigation";
import { withRouter } from 'react-router-dom';
import {connect} from "react-redux";
import EQHeader from './EQHeader';
import EQFooter from './EQFooter';
import EQMobileMenu from "./EQMobileMenu";

class EQ_3_1_5 extends Component {
constructor(props) {
super(props);
this.state = {
isValid: true,
mobileMenu: false
}
this.handleMobileMenu = this.handleMobileMenu.bind(this);
this.ShowContentRBReq1 = this.ShowContentRBReq1.bind(this);
}

componentDidMount() {
handleFormSubmit(this.props)
const script = document.createElement("script");
script.src = "/fbgc/scripts/utils.js?v=3.0";
script.async = true;
document.body.appendChild(script);
}

handleNext = (element) => {
const isValid = submitFormData()
if (isValid) {
element.className = element.className + " LoadingButton LoadingButton-loading";
pageDetails("fbgc", this.props.application.applicationData, "NEXT", "EQ-3.1.5", "PAGE_STATUS_COMPLETE").then((nextPage) => {
element.className = element.className.replace(" LoadingButton LoadingButton-loading", "")
if (nextPage != "") {
loadApplicationData("fbgc").then((data) => {
this.props.dispatch(data)
nextPage.includes("http") ? window.location.href = nextPage :
nextPage.includes("redirect") ? window.location.href = nextPage.split("redirect=")[1] :
this.props.history.push(nextPage);
});
}
});
} else {
this.setState({
isValid: isValid
})
}
}

handlePrevious = () => {
pageDetails("fbgc", this.props.application.applicationData, "PREV", "EQ-3.1.5", "PAGE_STATUS_NOT_VISITED").then((prevPage) => {
this.props.history.push(prevPage);
});
}

hasBack = () => {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   return !isFirstPage("EQ-3.1.5", ["EQ-1.1","EQ-2.2.6","EQ-2.3","EQ-2.3.1","EQ-2.3.2","EQ-2.3.3","EQ-2.3.4","EQ-2.3.5","EQ-3.1","EQ-3.1.1","EQ-3.1.2","EQ-2.1","EQ-3.1.3","EQ-3.1.4","EQ-3.1.5","EQ-3.2","EQ-3.2.1","EQ-3.2.2","EQ-3.2.3","EQ-3.2.4","EQ-3.2.5","EQ-3.2.6","EQ-2.1.1","EQ-3.3","EQ-3.3.1","EQ-3.3.2","EQ-3.3.3","EQ-3.3.4","EQ-3.3.5","EQ-4.1","EQ-4.1.1","EQ-4.1.2","EQ-4.1.3","EQ-2.2","EQ-4.2","EQ-4.2.1","EQ-4.2.2","EQ-4.2.3","EQ-4.2.4","EQ-4.2.5","EQ-4.2.6","EQ-5.1","EQ-5.1.1","EQ-5.1.2","EQ-2.2.1","EQ-5.1.3","EQ-5.2","EQ-5.2.1","EQ-5.2.2","EQ-5.2.3","EQ-5.2.4","EQ-5.2.5","EQ-6.1","EQ-6.1.1","EQ-6.1.2","EQ-2.2.2","EQ-6.2","EQ-6.2.1","EQ-6.2.2","EQ-6.2.3","EQ-6.2.4","EQ-2.2.3","EQ-2.2.4","EQ-2.2.5"]);
}

handleMobileMenu(value) {
this.setState({
mobileMenu: value
})
}

ShowContentRBReq1(var1, var2) {
if (document.getElementById(var2).checked) {
document.getElementById(var1).style.display = "block";
} else {
document.getElementById(var1).style.display = "none";
}
}

render() {
return (
<div className="Site">
    <EQHeader handleMobileMenu={(value) => this.handleMobileMenu(value)}/>
    <div className="SiteContent">
        <div className="SiteContent-container">
            <div className="App">
                <div className="EqSubHeader">
                    <div className="EqSubHeader-form">
                        <FormatMessage id="form.title"/>	
                    </div>
                    <div className="EqSubHeader-label">
                        <FormatMessage id="eq-pageheader"/>
                    </div>
                </div>
                <div className="FixedLayout App-layout">
                    <div className="FixedLayoutAside App-aside">
                        <EQLeftNavigation hasSidebar="true" closedSectionKey="eq.lnt.section.closed"/>
                    </div>
                    <div className="FixedLayoutMain App-main">
                        <div className="Page">
                            <form id="application_form">
                                <div className="EqQuestionPage">
                                    {!this.state.isValid &&
                                    <div className="PageError">
                                        <div className="PageError-label">
                                            <FormatMessage id="control.complete.highlightedfields"/>
                                        </div>
                                    </div>
                                    }
                                    <div className="Questions EqQuestionPage-questions">
                                                                                                                                                                            <div className="QuestionSectionGroup" id="section-3.1.5.1">
                                                                                                                                                                <RadioOptionWithValue beanName="applicationData" property="quiz.sponsorBecomingCitizenChild" personalisation="true" 
questionKey="eq3.1.5.pagetext" 
option_label_1="eq3.1.5.pagetext.radio1" 
option_label_2="eq3.1.5.pagetext.radio2" 
option_label_3="eq3.1.5.pagetext.radio3" 
option_value_1="citizenInProcess" 
option_value_2="citizenCheck" 
option_value_3="otherCheck" 
required="true" 
errorKey="error.control.pleaseselect" 
instructionText="eq3.1.5.instructionText" 
 application={this.props.application} dispatchApplicationData={this.dispatchApplicationData.bind(this)} />
                                                                                                                                                        </div>
                                                                                                                        </div>
                                    <EQ_Button_Navigation hasBack={this.hasBack()}
                                                          navNext={this.handleNext}
                                                          navPrevious={this.handlePrevious}>
                                    </EQ_Button_Navigation>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <EQFooter />
</div>)
}
dispatchApplicationData(applicationData) {
this.setState({
isValid: true
})
this.props.dispatch(saveApplicationData(applicationData))
}
}

const mapStateToProps = state => {
return {
application: state.application
}
}

export default connect(mapStateToProps)(injectIntl(withRouter(EQ_3_1_5)))
